import {
  INITIAL_GET_TITLE_COMPANY_PARAMS,
  INITIAL_TITLE_COMAPNY_TABLE_DATA,
  UserFilter,
} from "./consts";
import { useEffect, useRef, useState } from "react";
import { TableData, TableDataItem, TableDataItemValue } from "types/components";
import { useTitleStore, useUserStore } from "store";
import { useGetTitleCompanies, useGetUsers } from "hooks";
import { UsersInStore } from "types/store";
import { Table } from "components/common";
import { TitleCompanies } from "types/entities";

interface OwnProps {
  setOpenUpdateUserDrawer: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedTitleCompany: React.Dispatch<React.SetStateAction<string>>;
  setModalTabs: React.Dispatch<React.SetStateAction<string>>;
}

export const TitleCompanyTable: React.FC<OwnProps> = ({
  setOpenUpdateUserDrawer,
  setSelectedTitleCompany,
  setModalTabs,
}) => {
  const { titleCompanies } = useTitleStore();
  const { getTitleCompanies } = useGetTitleCompanies();
  const [titleCompaniesData, setTitleCompaniesData] = useState<TableData>({
    ...INITIAL_TITLE_COMAPNY_TABLE_DATA,
  });
  const [userFilter, setUserFilter] = useState<UserFilter>(UserFilter.ALL);
  const [check, setCheck] = useState<boolean>(false);

  const handleRowClick = (
    item: TableDataItem,
    setStateFunc: React.Dispatch<React.SetStateAction<any>>, // changed to any if you're conditionally setting id or object
    setOpenUpdateUserDrawer: React.Dispatch<React.SetStateAction<boolean>>
  ) => {
    const currentPath = window.location.href;

    if (currentPath.includes("title-companies")) {
      setStateFunc(item);
    } else {
      setStateFunc(item.id as string);
    }

    setOpenUpdateUserDrawer(true);
    setModalTabs("information");
  };

  const mapTitleCompaniesToTableData = (
    data: TitleCompanies[],
    initialTableData: TableData,
    setStateFunc: React.Dispatch<React.SetStateAction<TableData>>
  ) => {
    const newTableData: TableData = { ...initialTableData, data: [] };

    data?.forEach((item) => {
      const tableItem: TableDataItem = {};
      // Make sure every tableItem contains 'id' field
      tableItem.id = item.id;

      newTableData.headers.forEach((header) => {
        const key = header.key as keyof TitleCompanies;
        tableItem[key] = item[key] as TableDataItemValue;
      });
      newTableData.data.push(tableItem);
    });
    setStateFunc({ ...newTableData });
  };

  const fetchData = () => {
    getTitleCompanies();
  };

  useEffect(() => {
    fetchData();
  }, [userFilter, check]);

  useEffect(() => {
    mapTitleCompaniesToTableData(
      titleCompanies,
      INITIAL_TITLE_COMAPNY_TABLE_DATA,
      setTitleCompaniesData
    );
  }, [titleCompanies]);

  return (
    <>
      {/* <RadioGroup
          onChange={setUserFilter}
          value={userFilter}
          label="Filter users"
          name="user-filters"
          options={[
            {
              label: "All",
              value: UserFilter.ALL,
            },
            {
              label: "Vendors",
              value: UserFilter.VENDORS,
            },
            {
              label: "Specialists",
              value: UserFilter.SPECIALISTS,
            },
            {
              label: "Admins",
              value: UserFilter.ADMINS,
            },
          ]}
        /> */}

      <Table
        setCheck={setCheck}
        tableData={titleCompaniesData}
        onRowClick={(item) =>
          handleRowClick(item, setSelectedTitleCompany, setOpenUpdateUserDrawer)
        }
      />
    </>
  );
};
